import React from 'react';
import IOSAppReviewDemo from './IOSAppReviewDemo';
import MacAppReviewDemo from './MacAppReviewDemo';

export default function AppReviewDemo() {
  const platform = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('platform')
    : '';

  return platform === 'macos' ? <MacAppReviewDemo /> : <IOSAppReviewDemo />;
}
